<template>
  <div class="menu-wrap">
    <div class="menu-vue" @click="openMenu()" title="打开快捷菜单">
      <img src="@/assets/img/float-menu.png" width="32px" alt="">
      
    </div>
    <div class="menu-items close" id="menu-items-box" v-show="drawerFlag">
      <div class="menu-item" @click="openurl('/message')">
        <div class="img">
          <img src="@/assets/img/xiaoxiguanli.png" width="28px" alt="">
        </div>
        <div class="text">消息管理</div>
      </div>
      <div class="menu-item" @click="openurl('/mydatabase')">
        <div class="img">
          <img src="@/assets/img/ziyouyingguangshujuku.png" width="28px" alt="">
        </div>
        <div class="text">自有荧光指纹数据库</div>
      </div>
      <div class="menu-item" @click="openurl('/fluorescence')">
        <div class="img">
          <img src="@/assets/img/shujukuduibifenxi.png" width="28px" alt="">
        </div>
        <div class="text">数据库对比分析</div>
      </div>
      <div class="menu-item" @click="openurl('/similarity')">
        <div class="img">
          <img src="@/assets/img/xiangsidujisuanfenxi.png" width="28px" alt="">
        </div>
        <div class="text">相似度计算分析</div>
      </div>
      <div class="menu-item" @click="openurl('/spectraltraceability')">
        <div class="img">
          <img src="@/assets/img/yingguangshuoyuanfenxi.png" width="28px" alt="">
        </div>
        <div class="text">荧光指纹溯源分析</div>
      </div>
      <div class="menu-item" @click="openurl('/')">
        <div class="img">
          <img src="@/assets/img/zhuye.png" width="28px" alt="">
        </div>
        <div class="text">首页</div>
      </div>
    </div>
  
  </div>
</template>

<script setup>
import { ref } from "vue";
import router from '@/router';

const drawerFlag = ref(false);


const openMenu = () => {
  if(drawerFlag.value) {
    document.getElementById("menu-items-box").classList.remove('open');
    document.getElementById("menu-items-box").classList.add('close')
    setTimeout(() => {
      drawerFlag.value = false;
    }, 800);
  } else {
    document.getElementById("menu-items-box").classList.remove('close');
    document.getElementById("menu-items-box").classList.add('open')
    drawerFlag.value = true;
  }
  
};


const openurl = (url) => {
    if(router.history.current.fullPath === url) {
        router.go(0);
    } else {
        router.push(url);
    }
    openMenu()
}
</script>

<style lang="scss" scoped>
.menu-vue {
  position: fixed;
  right: 69px;
  bottom: 124px;
  border-radius: 50%;
  width: 62px;
  height: 62px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  z-index: 99999;
  cursor: pointer;
  i {
    font-size: 30px;
    color: #fff;
  }
  &:hover {
    img {
      scale: 1.1;
      transition: all 0.6s;
    }
  }
  &:active {
    img {
      scale: 0.8;
      transition: all 0.3s;
    }
  }

  

}
.menu-items {
    width: 715px;
    height: 94px;
    background: rgba($color: #000000, $alpha: 0.6);
    border-radius: 94px;
    position: fixed;
    right: 53px;
    bottom: 110px;
    padding: 25px 50px 0 31px;
    overflow: hidden;
    white-space: nowrap;
    z-index: 99998;
    .menu-item {
      width: 106px;
      display: inline-block;
      text-align: center;
      color: #fff;
      font-size: 12px;
      cursor: pointer;
      .img {
        margin-bottom: 5px;
      }
      &:first-of-type {
        width: 68px;
      }
      &:nth-of-type(2) {
        width: 130px;
      }
      &:last-of-type {
        width: 48px;
      }
    }
}
.menu-items.open {
  animation: grow 1s forwards;
}
.menu-items.close {
  animation: shrink 1s forwards;
}
.content {
    overflow: hidden;
    padding: 10px;
}
.items {
  .item {
    padding: 10px;
    cursor: pointer;
    border-radius: 10px;

    &:hover {
      background: rgba(0, 0, 0, 0.1);
      transition: all 0.5s;
    }
    h3 {
      text-align: center;
      font-size: 16px;
      min-height: 42px;
    }
    p {
      margin-top: 20px;
      text-align: center;
      color: #000;
      max-width: 280px;
      margin: 10px auto;
    }

    .icon {
      text-align: center;
      margin-bottom: 20px;

      i {
        font-size: 40px;
        color: #000;
      }
    }
  }
}

@keyframes grow {
  0% {
    width: 94px;
    opacity: 0;
  }
  100% {
    width: 715px;
    opacity: 1;
  }
}

@keyframes shrink {
  0% {
    width: 715px;
    opacity: 1;
  }
  100% {
    width: 94px;
    opacity: 0;
  }
}

</style>